import { render, staticRenderFns } from "./EventIsClosed.vue?vue&type=template&id=fc4b9f4e&scoped=true"
import script from "./EventIsClosed.vue?vue&type=script&lang=js"
export * from "./EventIsClosed.vue?vue&type=script&lang=js"
import style0 from "./EventIsClosed.vue?vue&type=style&index=0&id=fc4b9f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4b9f4e",
  null
  
)

export default component.exports